
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","data-name":"vuesax/twotone/people"}},[_c('path',{attrs:{"d":"M29.996 11.933a1.009 1.009 0 00-.317 0 4.308 4.308 0 11.317 0z","stroke":"#f29030"}}),_c('path',{attrs:{"data-name":"Vector","d":"M28.279 24.067a9.391 9.391 0 006.567-1.2c2.35-1.567 2.35-4.133 0-5.7a9.45 9.45 0 00-6.617-1.184M9.946 11.933a1.009 1.009 0 01.317 0 4.308 4.308 0 10-.317 0zM11.662 24.067a9.391 9.391 0 01-6.567-1.2c-2.35-1.567-2.35-4.133 0-5.7a9.45 9.45 0 016.617-1.184","stroke":"#f29030"}}),_c('g',{attrs:{"stroke":"#245389"}},[_c('path',{attrs:{"data-name":"Vector","d":"M20 24.383a1.009 1.009 0 00-.317 0 4.308 4.308 0 11.317 0zM15.149 29.633c-2.35 1.567-2.35 4.133 0 5.7a9.462 9.462 0 009.7 0c2.35-1.567 2.35-4.133 0-5.7a9.539 9.539 0 00-9.7 0z"}})])])])
          )
        }
      }
    